import { Helmet } from "react-helmet";
import site, { absoluteUrl, heroSrcSet } from "../../data/site";

const OG_ALT = "DigitaliNation, a remote software and marketing studio in Islamabad";

export default function Seo({
  title,
  description,
  path = "/",
  jsonLd,
  noindex = false,
  preloadHero = false,
}) {
  const url = absoluteUrl(path);
  const robots = noindex
    ? "noindex, follow"
    : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1";

  return (
    <Helmet>
      <html lang="en" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="author" content={site.siteName} />
      <meta name="robots" content={robots} />
      {noindex ? null : <link rel="canonical" href={url} />}
      {noindex ? null : <link rel="alternate" hrefLang="en" href={url} />}
      {noindex ? null : <link rel="alternate" hrefLang="x-default" href={url} />}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={site.siteName} />
      <meta property="og:locale" content="en_US" />
      {noindex ? null : <meta property="og:url" content={url} />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={site.ogImage} />
      <meta property="og:image:secure_url" content={site.ogImage} />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={OG_ALT} />
      <meta name="twitter:card" content="summary_large_image" />
      {noindex ? null : <meta name="twitter:url" content={url} />}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={site.ogImage} />
      <meta name="twitter:image:alt" content={OG_ALT} />
      {preloadHero ? (
        <link
          rel="preload"
          as="image"
          href="/hero/hero-960.avif"
          type="image/avif"
          imageSrcSet={heroSrcSet("avif")}
          imageSizes={site.hero.sizes}
        />
      ) : null}
      {jsonLd ? (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      ) : null}
    </Helmet>
  );
}
